import React from 'react';
import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';
import ProtectedRoute from '../components/feature/ProtectedRoute';

const HomePage = lazy(() => import('../pages/home/page'));
const ContactosPage = lazy(() => import('../pages/contactos/page'));
const PricingPage = lazy(() => import('../pages/pricing/page'));
const FAQPage = lazy(() => import('../pages/faq/page'));
const PrivacyPolicyPage = lazy(() => import('../pages/privacy-policy/page'));
const TermsOfServicePage = lazy(() => import('../pages/terms-of-service/page'));
const CookiePolicyPage = lazy(() => import('../pages/cookie-policy/page'));
const FornecedoresPage = lazy(() => import('../pages/fornecedores/page'));
const NotFoundPage = lazy(() => import('../pages/NotFound'));

// Admin pages
const AdminLogin = lazy(() => import('../pages/admin/login/page'));
const AdminAuthCallback = lazy(() => import('../pages/admin/auth-callback/page'));
const AdminDashboard = lazy(() => import('../pages/admin/page'));
const AdminReservas = lazy(() => import('../pages/admin/reservas/page'));
const AdminMotoristas = lazy(() => import('../pages/admin/motoristas/page'));
const AdminFrota = lazy(() => import('../pages/admin/frota/page'));
const AdminManutencao = lazy(() => import('../pages/admin/manutencao/page'));
const AdminUtilizadores = lazy(() => import('../pages/admin/utilizadores/page'));
const AdminRelatorios = lazy(() => import('../pages/admin/relatorios/page'));
const AdminPerfil = lazy(() => import('../pages/admin/perfil/page'));
const AdminNotificacoes = lazy(() => import('../pages/admin/notificacoes/page'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/pricing',
    element: <PricingPage />,
  },
  {
    path: '/faq',
    element: <FAQPage />,
  },
  {
    path: '/contactos',
    element: <ContactosPage />,
  },
  {
    path: '/fornecedores',
    element: <FornecedoresPage />,
  },
  {
    path: '/privacy-policy',
    element: <PrivacyPolicyPage />,
  },
  {
    path: '/terms-of-service',
    element: <TermsOfServicePage />,
  },
  {
    path: '/cookie-policy',
    element: <CookiePolicyPage />,
  },
  {
    path: '/admin/login',
    element: <AdminLogin />,
  },
  {
    path: '/admin/auth-callback',
    element: <AdminAuthCallback />,
  },
  {
    path: '/admin',
    element: (
      <ProtectedRoute>
        <AdminDashboard />
      </ProtectedRoute>
    ),
  },
  {
    path: '/admin/reservas',
    element: (
      <ProtectedRoute>
        <AdminReservas />
      </ProtectedRoute>
    ),
  },
  {
    path: '/admin/motoristas',
    element: (
      <ProtectedRoute>
        <AdminMotoristas />
      </ProtectedRoute>
    ),
  },
  {
    path: '/admin/frota',
    element: (
      <ProtectedRoute>
        <AdminFrota />
      </ProtectedRoute>
    ),
  },
  {
    path: '/admin/relatorios',
    element: (
      <ProtectedRoute>
        <AdminRelatorios />
      </ProtectedRoute>
    ),
  },
  {
    path: '/admin/manutencao',
    element: (
      <ProtectedRoute>
        <AdminManutencao />
      </ProtectedRoute>
    ),
  },
  {
    path: '/admin/utilizadores',
    element: (
      <ProtectedRoute>
        <AdminUtilizadores />
      </ProtectedRoute>
    ),
  },
  {
    path: '/admin/perfil',
    element: (
      <ProtectedRoute>
        <AdminPerfil />
      </ProtectedRoute>
    ),
  },
  {
    path: '/admin/notificacoes',
    element: (
      <ProtectedRoute>
        <AdminNotificacoes />
      </ProtectedRoute>
    ),
  },
  {
    path: '*',
    element: <NotFoundPage />,
  },
];

export default routes;
